import { useFeatureAccessSettings } from '../featureAccessSettings';

type UseViewerCanCreateArticle = () => boolean;
export const useViewerCanCreateArticle: UseViewerCanCreateArticle = () => {
  const featureAccessSettings = useFeatureAccessSettings();

  return !!featureAccessSettings?.viewerCanCreateArticle;
};
